import React from 'react';
import ReactMarkdown from 'react-markdown';
import MathJax from 'react-mathjax';
import RemarkMathPlugin from 'remark-math';
import Definition from './definition';
import Merke from './merke';

function Markdown(props) {
  const newProps = {
    ...props,
    plugins: [
      RemarkMathPlugin,
    ],
    renderers: {
      ...props.renderers,
      math: (p) =>
        <MathJax.Node formula={p.value} />,
      inlineMath: (p) =>
        <MathJax.Node inline formula={p.value} />,
      code: (p) => {
        if (p.language != null) {
          const l = p.language.toLowerCase();
          if (l === 'merke')
            return <Merke content={<ReactMarkdown {...newProps} source={p.value} />} />;
          else if (l.startsWith('definition'))
            return <Definition name={p.language.indexOf('_') !== -1 ? p.language.substring(p.language.indexOf('_') + 1, p.language.length).replaceAll('_', ' ') : ''} content={<ReactMarkdown {...newProps} source={p.value} />} />;
        }
        return ReactMarkdown.renderers.code(p);
      },
      image: (p) => {
        var src = p.src;
        var width = '100%';
        // check if image has size (@n%)
        const at = p.src.search(/@[0-9]{1,3}%$/);
        if (at >= 0) {
          width = p.src.substring(at + 1);
          src = p.src.substring(0, at);
        }
        // check if image is local (no http:// or https://)
        if (p.src.search(/http(s)?:\/\//) !== 0) {
          try {
            src = require('../img/' + src);
          } catch (e) {
            src = '';
          }
        }
        return <span style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'baseline' }}><img {...p} src={src} alt={p.alt} title={p.alt} width={width} /></span>;
      }
    }
  };
  return (
    <MathJax.Provider input="tex">
      <ReactMarkdown {...newProps} />
    </MathJax.Provider>
  );
}

export default Markdown;
